import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

import { IHeaderItem } from 'src/app/models/generic';
import { IFieldOrder } from 'src/app/models/manual-batch';

enum OrderEnum {
  UP = 1,
  DOWN = -1,
  NULL = 0
}

@Component({
  selector: 'app-ordered-header-list',
  templateUrl: './ordered-header-list.component.html',
  styleUrls: ['./ordered-header-list.component.scss']
})
export class OrderedHeaderListComponent {
  @Input() headerItems: IHeaderItem[] = [];
  
  @Output() orderChangeEvent = new EventEmitter<IFieldOrder[]>();

  @Input() @HostBinding('style.--min-width') minWidth?: string;

  OrderEnum = OrderEnum;
  orderChange: { [key: string]: number } = {
    [OrderEnum.NULL]: OrderEnum.UP,
    [OrderEnum.UP]: OrderEnum.DOWN,
    [OrderEnum.DOWN]: OrderEnum.NULL
  };

  fieldsOrder: IFieldOrder[] = [];

  constructor() {}

  changeOrderValue(item: IHeaderItem): void {
    item.orderValue = this.orderChange[`${item.orderValue}`];

    let orderItem = this.fieldsOrder.find(
      (field) => field.Field === item.name
    ) as IFieldOrder;
    let index = this.fieldsOrder.indexOf(orderItem);

    if (!!orderItem) {
      if (item.orderValue === OrderEnum.NULL) {
        this.fieldsOrder.splice(index, 1);
      } else {
        orderItem.Order = item.orderValue;
      }
    } else {
      this.fieldsOrder.push({ Field: item.name!, Order: item.orderValue });
    }

    this.orderChangeEvent.emit([...this.fieldsOrder]);
  }
}
